import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { OrdersService } from '../../../../services/orders';
import { UserService } from '../../../../services/user';
import { Order } from '../../../../interfaces/order';
import { Router } from '@angular/router';
import { LoginService } from '../../../Authentication/auth/login.service';
import { CartService } from '../../../../services/cart';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss'
})
export class OrdersComponent implements OnInit {

  contentReady = false;
  noData = false;

  isAr = false;
  allData: Order[] = [];
  ordersTotal!: any;
  tokenExists = false;

  private isBrowser: boolean;

  constructor(
    private _orderService: OrdersService,
    private router: Router,
    private _LoginService: LoginService,
    private _userService: UserService,
    private cartService: CartService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // language → browser only
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.checkForToken();
  }

  // ================= AUTH =================
  checkForToken(): void {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;

      if (this.tokenExists) {
        this.getUserOrders(1);
      }
    });
  }

  // ================= NAVIGATION =================
  invoice(order: any): void {
    this.router.navigate(['/invoice'], { queryParams: order });
  }

  details(order: any): void {
    this.router.navigate(['/orderdetails'], { queryParams: order });
  }
  goBack(): void {
    window.history.back();
  }
  // ================= DATA =================
  getUserOrders(page: number): void {
    this.contentReady = true;

    this._userService.getUserId().subscribe({
      next: (data) => {
        this._orderService.getOrderByUserId(data.user_id, page).subscribe({
          next: (res) => {
            this.allData = res.data;
            this.ordersTotal = res.total;

            this.noData = this.allData.length === 0;
            this.contentReady = false;
          },
          error: (error) => {
            console.error(error);
            this.contentReady = false;
          },
        });
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      },
    });
  }

  // ================= HELPERS =================
  convertDate(dateString: any): string {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  canRefund(dateString: any): boolean {
    const orderDate = new Date(dateString);
    const today = new Date();
    const diffDays =
      (today.getTime() - orderDate.getTime()) / (1000 * 3600 * 24);

    return diffDays <= 15;
  }

  // ================= ORDER ACTIONS =================
  orderStatuschange(orderId: any, status: any): void {
    this.contentReady = true;

    this._orderService.changeStatus(orderId, status, 'by client').subscribe({
      next: () => {
        if (status === 3) {
          this.updateQuantity(status, orderId);
        } else {
          this.getUserOrders(1);
        }
      },
      error: (err) => {
        console.log(err);
        this.contentReady = false;
      },
    });
  }

  updateQuantity(status: any, orderId: any): void {
    this._orderService.updateQty(status, String(orderId)).subscribe({
      next: () => {
        this.getUserOrders(1);
      },
      error: (err) => console.log(err),
    });
  }

  // ================= REORDER =================
  reorder(products: any[], quantiy: any[]) {
    this._orderService.getByIds(products).subscribe({
      next: (data: any) => {  // هنا خليه any مش any[]
        (data as any[]).forEach((element, i) => {
          const qty = quantiy[i] ?? 1;
          this.addToCart(element, qty);
          this.router.navigate(['/cart']);
        });
      },
      error: (err) => {
        console.error('Error fetching stocks:', err);
      }
    });

  }

  addToCart(product: any, quantity: any): void {
    if (!this.isBrowser) return;
    this.cartService.addToCart(product);
  }

  // ================= CONTACT =================
  extractPhone(str: string): string | null {
    const match = str.match(/\d+/);
    return match ? match[0] : null;
  }

  callHero(info: string): void {
    if (!this.isBrowser) return;

    const phone = this.extractPhone(info);
    if (phone) {
      window.open(`tel:+${phone}`, '_blank');
    }
  }

  chatWithHero(info: string): void {
    if (!this.isBrowser) return;

    const phone = this.extractPhone(info);
    if (phone) {
      window.open(`https://api.whatsapp.com/send?phone=2${phone}`, '_blank');
    }
  }
}
